import {
  NgClass,
  NgOptimizedImage
} from '@angular/common';
import {
  Component,
  inject
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgxTolgeeModule } from '@tolgee/ngx';

import { InnerHtmlComponent } from '../shared/components/inner-html/inner-html.component';
import { HoverGradientDirective } from '../shared/directives/hover-gradient.directive';
import { Universe } from '../shared/model/universe.model';
import { SiteService } from '../shared/services/site.service';
import { UniverseService } from '../shared/services/universe.service';

@Component({
  selector: 'app-universes',
  imports: [
    NgxTolgeeModule,
    NgOptimizedImage,
    HoverGradientDirective,
    RouterLink,
    InnerHtmlComponent,
    NgClass
  ],
  templateUrl: './universes.component.html'
})
export class UniversesComponent {
  universeService = inject(UniverseService);
  universe: Universe | null = null;
  siteService = inject(SiteService);
}
